var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.989 2.274v19.452a1 1 0 0 0 1.517.855l16.069-9.725a1 1 0 0 0 0-1.712L4.506 1.419a1 1 0 0 0-1.517.855",
    className: "right_svg__right"
  })));
};
export default SvgRight;